import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TaxCreateDto,
  TaxDto,
  TaxExcelDownloadDto,
  TaxUpdateDto,
} from '../proxy/controlling/dtos/tax';
import { TAX_CONFIG, TAX_FIELDS } from './tax.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tax',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TaxService, ConfirmationService],
  templateUrl: './tax.html',
  styleUrl: './tax.scss',
})
export class Tax extends BaseHierarchicalCrudComponent<
  TaxDto,
  TaxCreateDto,
  TaxUpdateDto,
  TaxExcelDownloadDto
> {
  service = inject(TaxService);
  config = TAX_CONFIG;
  fields = TAX_FIELDS;

  protected prepareUpdateDto(data: any, selected: TaxDto): TaxUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Tax';
  }
}
